import { EditOutlined } from '@ant-design/icons'
import { Button, Form, Steps as StepsAntd } from 'antd'
import { array, arrayOf, func, number, shape, string } from 'prop-types'
import React, { useState } from 'react'
import StepModal from './stepModal'
const { Step } = StepsAntd

const Workflow = ({ workflowContext }) => {
	const {
		steps,
		current_step_id,
		editCurrentStep,
		handleStepCompleted,
		handleStepRejected,
		groupsList,
	} = workflowContext

	const tailLayout = {
		wrapperCol: { span: 24 },
	}

	const [stepModal, setStepModal] = useState(false)

	const showStepModal = () => {
		setStepModal(true)
	}

	const handleStepEditCancelled = () => {
		setStepModal(false)
	}

	const handleStepEditSubmited = (values) => {
		editCurrentStep(values)
		setStepModal(false)
	}

	const isCurrentStep = (index) => {
		return index === current_step_id
	}
	const isStepCompleted = (index) => {
		return index < current_step_id
	}

	const stepHasDueDate = (index) => {
		return steps[index].due_date !== null
	}

	const stepHasResponsibleGroup = (index) => {
		return steps[index].responsible_group !== null
	}

	const isWorkflowCompleted = () => {
		return current_step_id === steps.length - 1
	}

	const formatDate = (date, withTime = false) => {
		var formatedDate = '-'
		try {
			// formatedDate = Intl.DateTimeFormat('pt-BR').format(new Date(date))
			formatedDate = new Date(date).toLocaleString('pt-BR')
			if (!withTime) {
				formatedDate = formatedDate.split(', ')[0]
			}
		} catch (e) {
			console.log(e)
		}
		return formatedDate
	}

	const getStepTitle = (index, showStepModal) => {
		if (isCurrentStep(index)) {
			return (
				<span
					style={{
						color: 'var(--ant-primary-color)',
						fontSize: 18,
						fontWeight: '500',
					}}>
					{steps[index].title}
					{(stepHasDueDate(index) || stepHasResponsibleGroup(index)) && (
						<EditOutlined
							style={{ padding: 2 }}
							onClick={() => showStepModal()}
						/>
					)}
				</span>
			)
		}
		return (
			<span style={{ fontSize: 18, fontWeight: '500', whiteSpace: 'nowrap' }}>
				{steps[index].title}
			</span>
		)
	}

	const getStepDescription = (index) => {
		if (isStepCompleted(index)) {
			return (
				<>
					{steps[index].approved_by && (
						<div style={{ fontSize: 12, lineHeight: 1.5 }}>
							Aprovado por:{' '}
							<span style={{ fontWeight: 'bold' }}>
								{steps[index].approved_by.name}
							</span>
						</div>
					)}
					{steps[index].approved_at && (
						<div style={{ fontSize: 12, lineHeight: 1.5 }}>
							em:{' '}
							<span style={{ fontWeight: 'bold' }}>
								{formatDate(steps[index].approved_at, true)}
							</span>
						</div>
					)}
					{steps[index].derived_document_id && (
						<div style={{ fontSize: 12, lineHeight: 1.5 }}>
							<a
								href={`${process.env.REACT_APP_BASE_URL}/documents/${steps[index].derived_document_id}`}>
								Clique aqui para visualizar o documento criado
							</a>
						</div>
					)}
				</>
			)
		}
		if (isCurrentStep(index)) {
			if (stepHasDueDate(index) || stepHasResponsibleGroup(index)) {
				return (
					<>
						{stepHasDueDate(index) && (
							<div style={{ fontSize: 12, lineHeight: 1.5 }}>
								Prazo:{' '}
								<span style={{ fontWeight: 'bold' }}>
									{formatDate(steps[index].due_date)}
								</span>
							</div>
						)}
						{stepHasResponsibleGroup(index) && (
							<div style={{ fontSize: 12, lineHeight: 1.5 }}>
								Grupo:{' '}
								<span style={{ fontWeight: 'bold' }}>
									{steps[index].responsible_group.name}
								</span>
							</div>
						)}
					</>
				)
			}
		}
	}

	return (
		<>
			{stepModal && (
				<StepModal
					showModal={stepModal}
					handleCancel={handleStepEditCancelled}
					handleSave={handleStepEditSubmited}
					steps={steps}
					current_step_id={current_step_id}
					groupsList={groupsList}
				/>
			)}
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					padding: 24,
					paddingRight: 5,
					margin: 5,
					minHeight: 200,
					background: '#fff',
				}}>
				<StepsAntd
					style={{
						marginTop: '5%',
						marginBottom: '5%',
					}}
					progressDot
					direction="vertical"
					current={current_step_id}
					labelPlacement="vertical">
					{steps.map((item, index) => (
						<Step
							style={{
								paddingBottom: '30px',
							}}
							key={index}
							title={getStepTitle(index, showStepModal)}
							description={getStepDescription(index)}
						/>
					))}
				</StepsAntd>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
					}}>
					<Form.Item {...tailLayout}>
						{!isWorkflowCompleted() && current_step_id !== null && (
							<div style={{ display: 'flex', gap: 10 }}>
								<Button
									type="primary"
									htmlType="button"
									onClick={handleStepCompleted}>
									Aprovar
								</Button>
								<Button
									type="primary"
									danger
									htmlType="button"
									onClick={handleStepRejected}>
									Cancelar
								</Button>
							</div>
						)}
					</Form.Item>
				</div>
			</div>
		</>
	)
}

Workflow.propTypes = {
	workflowContext: shape({
		steps: array.isRequired,
		current_step_id: number.isRequired,
		editCurrentStep: func.isRequired,
		handleStepCompleted: func.isRequired,
		handleStepRejected: func,
		groupsList: arrayOf(
			shape({
				id: number.isRequired,
				name: string.isRequired,
			})
		).isRequired,
	}).isRequired,
}

export default Workflow
